import React from "react";

import ArrowRight from "../components/ArrowRight";
import AlreadyHaveAccount from "../components/AlreadyHaveAccount";
import BuildingIcon from "../components/BuildingIcon";

/**
 * Step 2 — "Wie heißt dein Unternehmen?"
 * Single text input. Stored as the organisation/account name. Non-empty to proceed.
 */
const CompanyNameStep = ({ companyName, setCompanyName, onNext }) => {
    const canProceed = companyName.trim().length > 0;

    const submit = (e) => {
        e.preventDefault();
        if (canProceed) onNext();
    };

    return (
        <form className="registration-step registration-step--company" onSubmit={submit} data-cy="registration-step-company">
            <p className="registration-step__eyebrow">Fast geschafft</p>
            <h1 className="registration-step__title">Wie heißt dein Unternehmen?</h1>

            <div className="registration-field">
                <span className="registration-field__icon">
                    <BuildingIcon />
                </span>
                <input
                    type="text"
                    className="registration-input registration-input--with-icon"
                    placeholder="Name deines Unternehmens"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    autoFocus
                    data-cy="registration-company-input"
                />
            </div>

            <button
                type="submit"
                className="registration-cta"
                disabled={!canProceed}
                data-cy="registration-company-next"
            >
                Weiter <ArrowRight />
            </button>

            <AlreadyHaveAccount />
        </form>
    );
};

export default CompanyNameStep;
